import { render, staticRenderFns } from "./TitleList.vue?vue&type=template&id=2d19a737&"
import script from "./TitleList.vue?vue&type=script&lang=js&"
export * from "./TitleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports